<div class="alert alert-warning chat-message-alert js-alert-message alert-dismissible"
     [hidden]="!(editorMessages && editorMessages.length > 0)">
  <button type="button" (click)="onCloseClick()" id="alert-box-close-button">
    <svg-icon icon="x"></svg-icon>
  </button>
  <p *ngFor="let editorMessage of editorMessages" [attr.data-automation-id]="'bc-editor-message'">
    {{ editorMessage.message | translate: editorMessage.translateParams }}
  </p>
</div>
